import { PHYSICS } from '../../config/settings';
import { MoveContext, MovementState } from './MovementState';

/** Running on the street or a rooftop: snappy horizontal control + jump. */
export class GroundedState implements MovementState {
  readonly name = 'grounded';

  update({ player, wish, dt, input }: MoveContext): void {
    const targetX = wish.x * PHYSICS.RUN_SPEED;
    const targetZ = wish.z * PHYSICS.RUN_SPEED;
    const blend = Math.min(1, dt * PHYSICS.RUN_ACCEL);
    player.velocity.x += (targetX - player.velocity.x) * blend;
    player.velocity.z += (targetZ - player.velocity.z) * blend;

    if (input.isDown('Space')) {
      player.velocity.y = PHYSICS.JUMP_VELOCITY;
      player.grounded = false;
    }
  }
}
